import { useEffect, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import {
  MESSAGE_BOX_VARIANT_DANGER,
  MESSAGE_BOX_VARIANT_WARNING,
  MessageBox,
  SPACING_24,
  SpacingVertical
} from 'mailup-web-components'

import { notifyParent } from 'mailup-react-helpers'

import {
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RUNNING
} from 'Api/beQueueApi'
import BoxProgress from 'Pages/EmailSendingWizard/components/BoxProgress/BoxProgress'
import BoxSendingManage from 'Pages/EmailSendingWizard/components/BoxSendingManage/BoxSendingManage'
import BoxTotalRecipients from 'Pages/EmailSendingWizard/components/BoxTotalRecipients/BoxTotalRecipients'
import {
  checkProgressCallback,
  initProgressCallback
} from 'Pages/EmailSendingWizard/recoil/callbacks/callback'
import { progressState } from 'Pages/EmailSendingWizard/recoil/state/queue'
import { senderInfoState } from '../recoil/state/senderInfo'

import {
  PECPLUS_STATUS_ERROR_DESCR,
  PECPLUS_STATUS_IN_PROGRESS_DESCR
} from 'Constants'
import {
  STORE_KEY_ACCOUNT,
  evalCondition,
  storeGet
} from 'mailup-react-helpers'
import BoxFasciaDiNonDisturbo from './BoxFasciaDiNonDisturbo/BoxFasciaDiNonDisturbo'
import BoxSheduleSending from './BoxSheduleSending/BoxSheduleSending'
import BoxTotalRecipientsNew from './BoxTotalRecipientsNew/BoxTotalRecipientsNew'

const SendingWizardThirdStep = () => {
  const intl = useIntl()
  const { loaded, queueStatus } = useRecoilValue(progressState)
  const initProgress = useRecoilCallback(initProgressCallback, [])
  const checkProgress = useRecoilCallback(checkProgressCallback, [])
  const timer = useRef(true)
  const { idAsyncQueueConfig, pecPlusStatus } = useRecoilValue(senderInfoState)

  const scheduleVisibility = evalCondition(
    'NOT uo:NOSEND AND (NOT uo:NOSCHED OR NOT uo:NOIMMEDIATESEND)'
  )

  const account = storeGet(STORE_KEY_ACCOUNT)

  const abitudiniApertureEnabled =
    account.IdOffer !== 1 && account.IdOffer !== 6 // BANDA // SOLO SMS

  useEffect(() => {
    idAsyncQueueConfig && idAsyncQueueConfig > 0 && initProgress()
  }, [idAsyncQueueConfig])

  useEffect(() => {
    if (loaded && queueStatus === BEQUEUE_CONFIG_STATE_RUNNING) {
      timer.current = setInterval(() => checkProgress(), 1000)

      return () => clearInterval(timer.current)
    }
  }, [loaded, queueStatus])

  const handleGoToSettingsClick = () => {
    notifyParent('redirectMainFrame', [
      '/console/form_upd_nl.aspx?visualmode=1&tab=mittenti'
    ])
  }

  return (
    <>
      {pecPlusStatus === PECPLUS_STATUS_IN_PROGRESS_DESCR && (
        <>
          <MessageBox variant={MESSAGE_BOX_VARIANT_WARNING}>
            {intl.formatMessage(
              { id: 'Load.PecPlus.WarinigConfingInProgressNew' },
              {
                link: chunks => (
                  <a onClick={handleGoToSettingsClick}>{chunks}</a>
                )
              }
            )}
          </MessageBox>
          <SpacingVertical variant={SPACING_24} />
        </>
      )}
      {pecPlusStatus === PECPLUS_STATUS_ERROR_DESCR && (
        <>
          <MessageBox variant={MESSAGE_BOX_VARIANT_DANGER}>
            {intl.formatMessage(
              { id: 'Load.Common.ConfigPecErrorNew' },
              {
                link: chunks => (
                  <a onClick={handleGoToSettingsClick}>{chunks}</a>
                )
              }
            )}
          </MessageBox>
          <SpacingVertical variant={SPACING_24} />
        </>
      )}
      <BoxProgress />
      {!abitudiniApertureEnabled && <BoxTotalRecipients />}
      {abitudiniApertureEnabled && <BoxTotalRecipientsNew />}
      {scheduleVisibility && queueStatus !== BEQUEUE_CONFIG_STATE_FAILED && (
        <BoxSheduleSending />
      )}
      <BoxFasciaDiNonDisturbo />
      <BoxSendingManage />
    </>
  )
}

export default SendingWizardThirdStep
